var ArchiveSectorDialogModule = /** @class */ (function () {
    function ArchiveSectorDialogModule() {
    }
    return ArchiveSectorDialogModule;
}());
export { ArchiveSectorDialogModule };
